<template>
  <div class="course-promotion-lessons">
    <LandingLayout>
      <LandingSectionWrapper :background-color="course.backgroundColor">
        <h1 class="course-promotion-lessons__title">{{ course.title }}</h1>
        <div class="course-promotion-lessons__description">{{ course.description }}</div>

        <template v-if="lessons.length > 0">
          <PromotionMainVideo
            v-if="isMainVideoVisible"
            class="course-promotion-lessons__main-video"
            :description="course.videoDescription"
            :title="course.videoTitle"
            :video="mainVideo"
          />
          <PromotionLessons :lessons="filteredLessons"/>
        </template>
        <Loader v-else/>
      </LandingSectionWrapper>
      <LandingSectionWrapper
        v-for="(section,idx) in course.sections"
        :key="idx"
        v-bind="section"
      >
        <LandingSection
          v-bind="section"
        />
      </LandingSectionWrapper>
    </LandingLayout>
  </div>
</template>

<script>

import { mapActions, mapGetters, mapMutations } from 'vuex';
import LandingLayout from '@/components/landing/LandingLayout.vue';
import LandingSectionWrapper from '@/components/landing/LandingSectionWrapper.vue';
import PromotionMainVideo from '@/components/landing/PromotionMainVideo.vue';
import PromotionLessons from '@/components/landing/PromotionLessons.vue';
import LandingSection from '@/components/sections/LandingSection.vue';
import Loader from '@/components/Loader.vue';

const CREATOR_BUSINESS_SCHOOL_ID = '9WWPHCR3LyLIB8iuk6Tw';
const INTRODUCTION_MODULE_ID = 'Df4bl3TRxzO7Ok9nqlhM';

export default {
  name: 'CoursePromotionLessons',
  components: {
    Loader,
    LandingSection,
    PromotionLessons,
    PromotionMainVideo,
    LandingSectionWrapper,
    LandingLayout,
  },
  props: {
    course: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    INTRODUCTION_MODULE_ID,
  }),
  computed: {
    ...mapGetters({
      moduleClasses: 'school/user/moduleClasses',
    }),
    lessons() {
      return this.moduleClasses[INTRODUCTION_MODULE_ID] || [];
    },
    isMainVideoVisible() {
      const { mainVideo } = this;

      return mainVideo && mainVideo.src;
    },
    mainVideo() {
      const mainLesson = this.lessons.find(lesson => lesson.id === this.course.mainVideoId);

      if (!mainLesson) {
        return null;
      }

      return {
        src: mainLesson.video,
        poster: mainLesson.featuredImage,
      };
    },
    filteredLessons() {
      return this.lessons.filter(lesson => lesson.id !== this.course.mainVideoId);
    },
  },
  methods: {
    ...mapMutations({
      setCourseId: 'school/user/setCourseId',
    }),
    ...mapActions({
      fetchModulesAndClasses: 'school/user/fetchModulesAndClasses',
    }),
  },
  async mounted() {
    this.setCourseId(CREATOR_BUSINESS_SCHOOL_ID);
    await this.fetchModulesAndClasses();
  },
};
</script>


<style
  lang="scss"
  scoped
>
@import "~@/assets/scss/mixins";

.course-promotion-lessons {

  &__title {
    margin-bottom: 24px;

    font-size: 40px;
    line-height: 48px;
    text-align: center;
    font-weight: 600;
    color: var(--gray-1);

    @include media-lg() {
      font-size: 48px;
      line-height: 56px;
    }
  }

  &__description {
    margin-bottom: 32px;

    font-size: 16px;
    line-height: 24px;
    font-weight: 300;
    text-align: center;
    color: var(--gray-3);

    @include media-lg() {
      margin-bottom: 40px;

      font-size: 20px;
      line-height: 24px;
    }
  }

  &__main-video {
    padding-bottom: 32px;
    margin-bottom: 32px;
    border-bottom: 1px solid var(--muted);

    @include media-lg() {
      padding-bottom: 40px;
      margin-bottom: 40px;
    }
  }
}

</style>
